import countries from './Countries';
const stepFields = [
    {
        label: 'Full name',
        display: 'Full name',
        id: 'name',
        name: 'name',
        placeholder: '...',
        type: 'text',
        rules: 'required|max_length[128]'
    },
    {
        label: 'Address (line 1)',
        display: 'Address (line 1)',
        id: 'address1',
        name: 'address1',
        placeholder: '...',
        type: 'text',
        rules: 'required|max_length[128]'
    },
    {
        label: 'Address (line 2)',
        display: 'Address (line 2)',
        id: 'address2',
        name: 'address2',
        placeholder: '...',
        type: 'text',
        rules: 'max_length[128]'
    },
    {
        label: 'City',
        display: 'City',
        id: 'city',
        name: 'city',
        placeholder: '...',
        type: 'text',
        rules: 'required|max_length[128]'
    },
    {
        label: 'ZIP code',
        display: 'ZIP code',
        id: 'zip',
        name: 'zip',
        placeholder: '12344',
        type: 'text',
        rules: 'required'
    },
    {
        label: 'Country',
        display: 'Country',
        id: 'country',
        name: 'country',
        placeholder: 'select country',
        type: 'select',
        rules: 'required',
        values: countries.countries
    },
    {
        label: 'E-mail',
        display: 'E-mail',
        id: 'email',
        name: 'email',
        placeholder: '...',
        type: 'text',
        rules: 'required|valid_email'
    },
    {
        label: 'Phone',
        display: 'Phone',
        id: 'phone',
        name: 'phone',
        placeholder: '...',
        type: 'phone',
        rules: 'required|valid_phone'
    },
    {
        label: 'I agree with Terms of Service and give consent for my personal data to be processed in accordance with the Privacy Policy.',
        display: 'Agreement',
        id: 'agreement',
        name: 'agreement',
        placeholder: '',
        type: 'checkbox',
        rules: 'required'
    },
];

export default stepFields;



/** WEBPACK FOOTER **
 ** ./src/stores/Step2.js
 **/